import * as z from 'zod'

export const bookingSchema = z
  .object({
    arrive: z.string(),
    depart: z.string(),
    prettyId: z.string(),
    status: z.number(),
    token: z.string(),
    categories: z.string().array().optional(),
    primaryPhoto: z
      .object({
        url: z.object({
          masterImage: z.string(),
        }),
      })
      .optional(),
  })
  .optional()
  .nullable()

export const guestBookingSchema = z.object({
  error: z.string(),
  booking: bookingSchema,
  reviewId: z.string().optional().nullable(),
})

export type GuestBooking = z.infer<typeof guestBookingSchema>
export type GuestBookingBooking = z.infer<typeof bookingSchema>
